import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import type { SupportedLanguage } from '../types/language';
import { saveLanguagePreference, isValidLanguage } from '../utils/languageUtils';

export const useLanguageSwitch = () => {
  const { i18n } = useTranslation();

  const switchLanguage = useCallback(async (language: SupportedLanguage) => {
    if (!isValidLanguage(language)) {
      console.error(`Invalid language code: ${language}`);
      return;
    }

    try {
      await i18n.changeLanguage(language);
      saveLanguagePreference(language);
      document.documentElement.dir = i18n.dir();
      window.location.reload();
    } catch (error) {
      console.error('Failed to switch language:', error);
    }
  }, [i18n]);

  return {
    currentLanguage: i18n.language as SupportedLanguage,
    switchLanguage,
    isRTL: i18n.dir() === 'rtl'
  };
};